module.exports = __webpack_public_path__ + "img/login-img-1.64ce5a3a.png";